import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../hooks/useCart';

export default function Sepet() {
  const { items, removeFromCart, updateQuantity, clearCart, totalItems } = useCart();
  const navigate = useNavigate();

  const tlItems = items.filter(i => i.tour.currency === 'TL');
  const eurItems = items.filter(i => i.tour.currency === '€');

  const tlTotal = tlItems.reduce((s, i) => s + i.tour.price * i.quantity, 0);
  const eurTotal = eurItems.reduce((s, i) => s + i.tour.price * i.quantity, 0);

  if (totalItems === 0) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900 flex flex-col transition-colors duration-300">
        <Navbar />
        <div className="flex-1 flex items-center justify-center px-6 pt-20">
          <div className="text-center max-w-md">
            <div className="w-24 h-24 flex items-center justify-center bg-orange-50 rounded-full mx-auto mb-6">
              <i className="ri-shopping-cart-2-line text-orange-400 text-5xl" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">Sepetiniz Boş</h2>
            <p className="text-gray-500 dark:text-gray-400 mb-8">
              Henüz sepetinize tur eklemediniz. Hemen turları keşfetmeye başlayın!
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/gunubirlik-turlar"
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full font-semibold text-sm cursor-pointer whitespace-nowrap"
              >
                Günübirlik Turlar
              </Link>
              <Link
                to="/yurtdisi-turlar"
                className="border border-orange-400 text-orange-500 hover:bg-orange-50 px-6 py-3 rounded-full font-semibold text-sm cursor-pointer whitespace-nowrap"
              >
                Yurt Dışı Turlar
              </Link>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col transition-colors duration-300">
      <Navbar />

      <div className="flex-1 pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Sepetim</h1>
              <p className="text-gray-500 dark:text-gray-400 mt-1">{totalItems} tur seçildi</p>
            </div>
            <button
              onClick={() => clearCart()}
              className="flex items-center gap-2 text-red-400 hover:text-red-500 text-sm cursor-pointer transition-colors whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-delete-bin-line" />
              </div>
              Sepeti Temizle
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Cart Items */}
            <div className="lg:col-span-2 space-y-4">
              {items.map(item => (
                <div
                  key={item.tour.id}
                  className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 overflow-hidden"
                >
                  <div className="flex gap-4 p-5">
                    <div className="w-28 h-24 flex-shrink-0 rounded-xl overflow-hidden">
                      <img
                        src={item.tour.image}
                        alt={item.tour.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between gap-2">
                        <div>
                          <p className="text-xs text-orange-500 font-medium mb-1">
                            {item.tour.duration} {item.tour.durationUnit}
                          </p>
                          <h3 className="font-semibold text-gray-900 dark:text-white text-sm leading-snug line-clamp-2">
                            {item.tour.name}
                          </h3>
                        </div>
                        <button
                          onClick={() => removeFromCart(item.tour.id)}
                          className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-400 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                        >
                          <i className="ri-close-line text-lg" />
                        </button>
                      </div>

                      <div className="flex items-center justify-between mt-4">
                        <div className="flex items-center gap-2 bg-gray-50 dark:bg-gray-700 rounded-xl p-1">
                          <button
                            onClick={() => updateQuantity(item.tour.id, item.quantity - 1)}
                            className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-white dark:hover:bg-gray-600 transition-colors cursor-pointer text-gray-600 dark:text-gray-300"
                          >
                            <i className="ri-subtract-line text-sm" />
                          </button>
                          <span className="text-sm font-semibold w-6 text-center dark:text-white">
                            {item.quantity}
                          </span>
                          <button
                            onClick={() => updateQuantity(item.tour.id, item.quantity + 1)}
                            className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-white dark:hover:bg-gray-600 transition-colors cursor-pointer text-gray-600 dark:text-gray-300"
                          >
                            <i className="ri-add-line text-sm" />
                          </button>
                        </div>

                        <div className="text-right">
                          <p className="font-bold text-orange-500 text-lg">
                            {item.tour.currency === 'TL'
                              ? `₺${(item.tour.price * item.quantity).toLocaleString('tr-TR')}`
                              : `€${(item.tour.price * item.quantity).toLocaleString('tr-TR')}`}
                          </p>
                          {item.quantity > 1 && (
                            <p className="text-xs text-gray-400">
                              {item.tour.currency === 'TL'
                                ? `₺${item.tour.price.toLocaleString('tr-TR')} x ${item.quantity}`
                                : `€${item.tour.price} x ${item.quantity}`}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Summary */}
            <div className="lg:col-span-1">
              <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-6 sticky top-28">
                <h3 className="font-bold text-gray-900 dark:text-white text-lg mb-5">Sipariş Özeti</h3>

                <div className="space-y-3 mb-5">
                  {tlTotal > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500 dark:text-gray-400">TL Turlar Toplamı</span>
                      <span className="font-semibold dark:text-white">₺{tlTotal.toLocaleString('tr-TR')}</span>
                    </div>
                  )}
                  {eurTotal > 0 && (
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500 dark:text-gray-400">Euro Turlar Toplamı</span>
                      <span className="font-semibold dark:text-white">€{eurTotal.toLocaleString('tr-TR')}</span>
                    </div>
                  )}
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500 dark:text-gray-400">Toplam Tur Sayısı</span>
                    <span className="font-semibold dark:text-white">{totalItems}</span>
                  </div>
                </div>

                <div className="border-t border-gray-100 dark:border-gray-700 pt-4 mb-6">
                  {tlTotal > 0 && (
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-semibold text-gray-900 dark:text-white">Toplam (TL)</span>
                      <span className="text-xl font-bold text-orange-500">
                        ₺{tlTotal.toLocaleString('tr-TR')}
                      </span>
                    </div>
                  )}
                  {eurTotal > 0 && (
                    <div className="flex justify-between items-center">
                      <span className="font-semibold text-gray-900 dark:text-white">Toplam (€)</span>
                      <span className="text-xl font-bold text-orange-500">
                        €{eurTotal.toLocaleString('tr-TR')}
                      </span>
                    </div>
                  )}
                </div>

                <button
                  onClick={() => navigate('/rezervasyon')}
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-xl font-bold text-base transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-file-list-3-line" />
                  Rezervasyon Formuna Geç
                </button>

                <div className="flex items-center gap-2 mt-4 text-xs text-gray-400 justify-center">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shield-check-line text-green-500" />
                  </div>
                  <span>Güvenli rezervasyon sistemi</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
